import { REQUEST_STATE, SET_STATE_KEY } from './constants'
import { constantCase } from 'change-case'

let types = {}

const BASE_GETTERS = {
  PENDING: set => state =>
    state[`${SET_STATE_KEY}_${set.type}`][set.stateKey] === REQUEST_STATE.STATE_PENDING,
  DATA: set => state => state[`${SET_STATE_KEY}_${set.type}`][set.dataKey],
  // MODIFIED: set => state => state[`${SET_STATE_KEY}_${set.type}`][set.modifiedKey],
}

export const getBaseTypes = () => types
// export const getBaseTypes = stateSets =>
//   stateSets.reduce((result, set) => ({
//     ...Object.entries(BASE_TYPES).reduce(
//       (getterTypes, [baseType]) => ({
//         ...getterTypes,
//         [`${set.type}_${baseType}`]: [`${set.type}_${baseType}`],
//       }),
//       {},
//     ),
//   }))

export const getGetters = stateSets =>
  stateSets.reduce(
    (result, set) => ({
      ...result,
      ...Object.entries(BASE_GETTERS).reduce((getters, [baseType, baseTypeFn]) => {
        const getterId = constantCase(`${set.type}_${baseType}`)
        types[getterId] = getterId
        return {
          ...getters,
          [getterId]: baseTypeFn(set),
        }
      }, {}),
    }),
    {},
  )
